import { AnyAction } from 'redux';

import { reducerWrapper } from '../../support/utils';
import { EventsReducerType } from './Types/EventsReducerType';
import { FETCH_EVENTS_POPULARITY } from '../../actions/Events/EventsActions';

const INIT_STATE: EventsReducerType = {
  loading: true,
  data: [],
};

const Handler = (state: EventsReducerType, action: AnyAction) => {
  switch (action.type) {
    case FETCH_EVENTS_POPULARITY.response:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    default:
      return state;
  }
};

const TypelessHandler = (state: any, action: any) => {
  return Handler(state, action);
};

const EventsReducer = reducerWrapper(INIT_STATE, TypelessHandler, {
  request: [FETCH_EVENTS_POPULARITY],
  error: [FETCH_EVENTS_POPULARITY],
});

export default EventsReducer;
